import React, { useEffect, useState } from 'react';
import HeroSection from '../components/HeroSection';
import HowItWorksSection from '../components/HowItWorksSection';
import PowerfulFeaturesSection from '../components/PowerfulFeaturesSection';
import StorytellingSection from '../components/StorytellingSection';
import CTASection from '../components/CTASection';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = '/api';

function HomePage() {
  const navigate = useNavigate();
  const [checkingSession, setCheckingSession] = useState(true);

  // Check session and redirect to dashboard if user is already logged in
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/doctor-auth/check-session`, {
          credentials: 'include'
        });
        const data = await response.json();

        if (data.authenticated && data.data.doctor) {
          // User is logged in, redirect to dashboard
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Session check error:', error);
        // If error, just continue showing homepage
      } finally {
        setCheckingSession(false);
      }
    };

    checkSession();
  }, [navigate]);

  const navigateToLogin = () => {
    navigate('/login');
  };

  // Show loading state while checking session
  if (checkingSession) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <HeroSection />
      <HowItWorksSection />
      <PowerfulFeaturesSection />
      <StorytellingSection />
      <CTASection />
    </>
  );
}

export default HomePage;
